import React from "react";
import LeadsTableBody from "./LeadsTableBody";

/**
 * Wrapper for rendering Business Leads rows.
 */
function BusinessLeadsTable(props) {
  return <LeadsTableBody {...props} activeTab="Business Leads" />;
}

export default BusinessLeadsTable;

